import { call, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import api from 'services/api';

import { Creators as KafkaActions, Types as KafkaTypes } from 'store/ducks/kafka';

function filterKafkaMessage(filters) {
  if (filters !== null) {
    const search = filters.query !== '' ? `&search=${filters.query}` : '';
    const date_start =
      filters.date_start !== null ? `&date_start=${moment(filters.date_start).format('YYYY-MM-DD')}` : '';
    const date_end = filters.date_end !== null ? `&date_end=${moment(filters.date_end).format('YYYY-MM-DD')}` : '';
    const topic = filters.topic !== null && filters.topic.value !== null ? `&topic_id=${filters.topic.value}` : '';
    const status = filters.status !== null && filters.status ? `&status=${filters.status.map(item => item.value).join(',')}` : '';


    return `${date_start}${date_end}${search}${topic}${status}`;
  }

  return '';
}

function* getMessagesRequest(action) {
  try {
    const { page, filters } = action.payload;
    const filter = yield call(filterKafkaMessage, filters);
    const url = `store/v2/kafka/messages?page=${page}&per=50${filter}`;
    const response = yield call(api.get, url);

    yield put(KafkaActions.getMessagesSuccess(response.data, parseInt(page)));
  } catch (error) {
    yield put(KafkaActions.getMessagesFailure());
  }
}

export default function* sagaKafka() {
  yield takeLatest(KafkaTypes.GET_MESSAGES_REQUEST, getMessagesRequest);
}
